<template>
  <div v-if="visible" class="d-inline-block">
    <v-menu offset-y :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <v-btn depressed color="primary" class="ml-2 font-weight-bold" small rounded v-bind="attrs" v-on="on">
          <v-icon small class="mr-1">mdi-help-circle-outline</v-icon>
          <span style="margin-top: 2px">{{ $t('guide.needHelp') }}</span>
        </v-btn>
      </template>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="list-title">
              {{ $t('guide.userManual') }}
            </v-list-item-title>
            <v-list-item-subtitle class="list-subtitle black--text">
              {{ $t('guide.chooseFormat') }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item v-if="pdfDownloadUrl" :href="pdfDownloadUrl" target="_blank">
          <v-list-item-avatar class="rounded">
            <v-icon class="red lighten-5 red--text text-darken-5">mdi-text-box-outline</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="list-title">
              {{ $t('guide.pdfManual') }}
            </v-list-item-title>
            <v-list-item-subtitle class="list-subtitle black--text">
              {{ $t('guide.downloadPdf') }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="youtubeEmbedUrl" @click="openVideoDialog(youtubeEmbedUrl)">
          <v-list-item-avatar class="rounded">
            <v-icon class="blue lighten-4 blue--text text-darken-5">mdi-video-outline</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="list-title">
              {{ $t('guide.videoTutorial') }}
            </v-list-item-title>
            <v-list-item-subtitle class="list-subtitle black--text">
              {{ $t('guide.watchStepByStep') }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <div v-for="section in sections" :key="section.title" style="padding-bottom: 8px">
          <v-list-item style="background-color: #efefef">
            <v-list-item-content>
              <v-list-item-title class="list-title" style="margin-bottom: 0; font-size: 14px">
                {{ section.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="section.pdfDownloadUrl" :href="section.pdfDownloadUrl" target="_blank">
            <v-list-item-avatar class="rounded">
              <v-icon class="red lighten-5 red--text text-darken-5">mdi-text-box-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="list-title">
                {{ $t('guide.pdfManual') }}
              </v-list-item-title>
              <v-list-item-subtitle class="list-subtitle black--text">
                {{ $t('guide.downloadPdf') }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="section.youtubeEmbedUrl" @click="openVideoDialog(section.youtubeEmbedUrl)">
            <v-list-item-avatar class="rounded">
              <v-icon class="blue lighten-4 blue--text text-darken-5">mdi-video-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="list-title">
                {{ $t('guide.videoTutorial') }}
              </v-list-item-title>
              <v-list-item-subtitle class="list-subtitle black--text">
                {{ $t('guide.watchStepByStep') }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
    </v-menu>
    <v-dialog v-if="selectedYoutubeEmbedUrl" v-model="videoDialog" width="992">
      <v-card>
        <iframe
          :src="selectedYoutubeEmbedUrl"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    pdfDownloadUrl: {
      type: String,
      required: false,
    },
    youtubeEmbedUrl: {
      type: String,
      required: false,
    },
    sections: {
      type: Array,
      required: false,
      default: () => [],
      validator: (value) => {
        return (
          Array.isArray(value) &&
          value.every(
            (section) =>
              !!section &&
              typeof section === 'object' &&
              'title' in section &&
              typeof section.title === 'string' &&
              (('pdfDownloadUrl' in section && typeof section.pdfDownloadUrl === 'string') ||
                ('youtubeEmbedUrl' in section && typeof section.youtubeEmbedUrl === 'string'))
          )
        );
      },
    },
  },

  data() {
    return {
      videoDialog: false,
      selectedYoutubeEmbedUrl: null,
    };
  },

  computed: {
    visible() {
      return !!this.pdfDownloadUrl || !!this.youtubeEmbedUrl || this.sections.length > 0;
    },
  },

  methods: {
    openVideoDialog(youtubeEmbedUrl) {
      this.selectedYoutubeEmbedUrl = youtubeEmbedUrl;
      this.videoDialog = true;
    },
  },
};
</script>

<style scoped>
.list-title {
  font-weight: 600;
  margin-bottom: 6px;
}

.list-subtitle {
  font-size: 13px;
}

iframe {
  display: block;
  height: 100%;
  width: 100%;
  min-height: 560px;
}
</style>
